import { useEffect } from 'react';
import { auth, db } from '../lib/firebase';
import { doc, getDoc } from 'firebase/firestore';

export const useErudaConsole = () => {
  useEffect(() => {
    const initEruda = async () => {
      const user = auth.currentUser;
      
      if (!user) return;

      try {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        const userData = userDoc.data();
        
        // เปิด Eruda เฉพาะ Admin
        if (userData?.role === 'admin') {
          if (typeof window !== 'undefined' && (window as any).eruda) {
            (window as any).eruda.init();
            console.log('Eruda Console initialized for Admin');
          }
        }
      } catch (error) {
        console.error('Error checking admin role:', error);
      }
    };

    // รอให้ auth พร้อม
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        initEruda();
      }
    });

    return () => unsubscribe();
  }, []);
};
